import { Injectable } from '@angular/core';
import {tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {BaseService} from '@core/service/base.service';
import {HttpHeaders} from '@angular/common/http';
import {VertifyQuery} from '@shared/components/slide-captcha/slide-captcha.component';

@Injectable({
  providedIn: 'root'
})
export class SliderCaptchaService extends BaseService {
  // getHttpOptions = {
  //   headers: new HttpHeaders({
  //     'Content-Type':  'application/json'
  //   }),
  //   withCredentials: true
  // };

  getAuthImage(url: string): Observable<any> {
    return this.get(url)
      .pipe(
        tap( _ => console.log('slide_captcha: ' + url))
      );
  }

  vertifyAuthImage(url: string, query: VertifyQuery): Observable<any> {
    return this.post(url, query)
      .pipe(
        tap( _ => console.log('slide_captcha: ' + url))
      );
  }
}
